import {Component, EventEmitter, Input, Output} from '@angular/core';
import {HorseResponse} from '../../models/response.module';
import {Router} from '@angular/router';

@Component({
  selector: 'app-horse-card',
  standalone: false,
  templateUrl: './horse-card.html',
  styleUrl: './horse-card.css'
})
export class HorseCard {
  @Input() horse: HorseResponse
  @Output() editHorseClick = new EventEmitter<HorseResponse>();
  @Output() deleteHorseClick = new EventEmitter<HorseResponse>();

  horseGenders = [
    { label: 'Gelding', value: 0 },
    { label: 'Stallion', value: 1 },
    { label: 'Mare', value: 2 },
  ]

  constructor(private router: Router) {
  }

  goToThread() {
    this.router.navigate(['/recruiter-candidates/view/', this.horse.horse_id]);
  }

  getHorseGenderLabel(genderValue: number): string {
    return this.horseGenders.find(g => g.value === genderValue)?.label || 'Unknown';
  }

  emitEditHorseClick() {
    console.log("Emitting edit horse click for horse:", this.horse);
    this.editHorseClick.emit(this.horse);
  }

  emitDeleteHorseClick() {
    console.log("Emitting edit horse click for horse:", this.horse);
    this.deleteHorseClick.emit(this.horse);
  }

  protected readonly length = length;
}
